export default "/images/10103e80a2322a4107b33758d8f1a97d.avif";